import * as fromRoot from '../../../reducers';
import * as fromUser from './user.reducer';
import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { UserActionsUnion } from '../actions/user.actions';

export interface UserState {
  userData: fromUser.State;
}

export interface State extends fromRoot.State {
  userData: UserState;
}

export const reducers: ActionReducerMap<UserState, UserActionsUnion> = {
  userData: fromUser.reducer
};

export const selectUserState = createFeatureSelector<State, UserState>('userData');

export const selectCurrentUserState = createSelector(
  selectUserState,
  (state: UserState) => state.userData
);

export const getUser = createSelector(
  selectCurrentUserState,
  fromUser.getUser
);

export const getAllUsers = createSelector(
  selectCurrentUserState,
  fromUser.getAllUsers
);

export const getUsersLoading = createSelector(
  selectCurrentUserState,
  fromUser.getUsersLoading
);

export const getUsersLoaded = createSelector(
  selectCurrentUserState,
  fromUser.getUsersLoaded
);

export const getUsersSaving = createSelector(
  selectCurrentUserState,
  fromUser.getUsersSaving
);

export const getUserError = createSelector(
  selectCurrentUserState,
  fromUser.getUserError
);
